import { Alert, Snackbar } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const AdminLogin = () => {
  const [open, setOpen] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const navigate = useNavigate();
  const [username, setUsername] = useState();
  const [password, setPassword] = useState();
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [serverMessage, setServerMessage] = useState("");
  const handleLogin = async () => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/login`,
        {
          username,
          password,
        }
      );
      console.log(data);
      localStorage.setItem("admin",JSON.stringify(data))
      setServerMessage(data);
      setSuccess(true);
      setOpen(true);
      navigate('/admin')
    } catch (error) {
      setError(true);
      console.log(error.response.data.error);
      setServerMessage(error.response.data.error);
      setOpen(true);
    }
  };
  useEffect(() => {
    if(JSON.parse(localStorage.getItem("admin"))){
      navigate('/admin')
    }
  }, [])
  return (
    <div className="h-[100vh] flex bg-gray-200 items-center justify-center">
      <div className="flex flex-col justify-center bg-gray-500 rounded-lg sm:p-5 px-2 py-4">
        <h2 className="font-bold text-2xl text-white">Login</h2>
        <input
          className="border focus:border-[#FE4904] border-black-500 outline-none h-[50px] px-4 py-6 text-lg rounded-lg sm:w-[400px] w-[300px] my-3"
          type="text"
          placeholder="Username"
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          className="border focus:border-[#FE4904] border-black-500 outline-none h-[50px] px-4 py-6 text-lg rounded-lg sm:w-[400px] w-[300px] my-3"
          type="Password"
          placeholder="Password"
          onChange={(e) => setPassword(e.target.value)}
        />
        <button
          onClick={handleLogin}
          className="bg-gradient-to-r from-[#FE4904] to-[#F7164C] hover:from-[#F7164C] hover:to-[#FE4904] sm:px-10 sm:py-3 px-2 py-3 rounded-xl mt-2 text-white transition ease-in-out text-lg"
        >
          Login
        </button>
      </div>
      {/* {open && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert
            onClose={handleClose}
            severity={`${success}` ? "error" : "success"}
            sx={{ width: "100%" }}
          >
            {serverMessage}
          </Alert>
        </Snackbar>
      )} */}
    </div>
  );
};
export default AdminLogin;
